export enum TextContainerSpacing {
  ExtraTight = 'extra-tight',
  Tight = 'tight',
  Loose = 'loose',
}
